<template>
    <v-card>
        <v-card-title>
            {{ type }} Webhooks
        </v-card-title>
        <v-card-text>
            <v-progress-linear
                v-if="isLoading"
                indeterminate
                color="primary"
                class="mb-5">
            </v-progress-linear>

            <v-form v-else ref="form" >
                <v-list>
                    <v-col cols="12" md="12" sm="12" lg="5" class="p-0">

                        <!-- Loop through eventTypes -->
                        <v-list-item
                            v-for="event in eventTypes"
                            :key="event"
                            class="hoverable-list-item"
                        >
                            <v-list-item-content>
                                <div>
                                    Subscribe to <strong>{{ event }}</strong>
                                </div>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-checkbox
                                    :disabled="isLoading"
                                    v-model="selectedEventTypes"
                                    :value="event"
                                    color="primary"
                                />
                            </v-list-item-action>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>

                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn
                                    :disabled="isSaving"
                                    color="primary"
                                    small
                                    @click="subscribe()"
                                >
                                    <span v-if="isSaving">
                                        <v-progress-circular
                                            indeterminate
                                            size="12"
                                            width="2"
                                            color="primary darken-3">
                                        </v-progress-circular>
                                        Updating...
                                    </span>
                                    <span v-else>Update</span>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>

                    </v-col>
                </v-list>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'

export default {
    props: {
        id: { type: Number, default: null },
        type: { type: String, default: "" },
    },

    data() {
        return {
            isLoading: true,
            isSaving: false,
            eventTypes: [
                "salesorder.created",
                "salesorder.updated",
                "salesshipment.created",
                "salesshipment.deleted"
            ],
            selectedEventTypes: [],
        }
    },

    created() {
        this.fetchEvents();
    },

    methods: {
        fetchEvents() {
            this.$http
            .get('/api/webhooks/' + this.type.toLowerCase() + '/' + this.id)
            .then(({ data }) => {
                this.selectedEventTypes = data.EventTypes ?? [];
            })
            .catch((error) => {
                EventBus.$emit('show-error', 'Failed to fetch event subscriptions: ' + (error.response?.data?.message || error.message));
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        subscribe() {
            this.isSaving = true;
            this.$http
                .post('/api/webhooks/' + this.type.toLowerCase() + '/subscribe/'+ this.id, {
                    eventTypes: this.selectedEventTypes
                })
                .then(({ data }) => {
                    EventBus.$emit('show-success', 'Event subscription updated successfully');
                })
                .catch((error) => {
                    EventBus.$emit('show-error', 'Failed to update event subscription: ' + (error.response?.data?.message || error.message));
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },

        formatLabel(event) {
            // e.g. "salesorder.created" -> "Sales Order Created"
            return event
                .replace('.', ' ')
                .replace(/([a-z])([A-Z])/g, '$1 $2')
                .replace(/\b\w/g, l => l.toUpperCase())
        }
    }
}
</script>

<style scoped>
.hoverable-list-item {
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
  border-radius: 6px;
}

/* Fallback hover for all themes (works even if theme classes are outside scope) */
.hoverable-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
  /* underline without affecting layout */
  box-shadow: inset 0 -1px #e0e0e0;
}
</style>